module.exports = __webpack_public_path__ + "img/rolex.679b03b4.png";